import React, { useState } from 'react';

export interface ProjectsProps {}

interface ProjectBoxProps {
    title: string;
    subtitle: string;
    externalUrl: string;
}

const ProjectBox: React.FC<ProjectBoxProps> = ({
    title,
    subtitle,
    externalUrl,
}) => {
    const [, setIsHovering] = useState(false);

    const handleClick = () => {
        window.open(externalUrl, '_blank', 'noopener,noreferrer');
    };

    const onMouseEnter = () => {
        setIsHovering(true);
    };

    const onMouseLeave = () => {
        setIsHovering(false);
    };

    return (
        <div
            onMouseDown={handleClick}
            className="big-button-container"
            style={styles.projectLink}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div style={styles.projectLinkLeft}>
                <div style={styles.projectText}>
                    <h1 style={{ fontSize: 48 }}>{title}</h1>
                    <h3>{subtitle}</h3>
                </div>
            </div>
            <div style={styles.projectLinkRight}></div>
        </div>
    );
};

const Projects: React.FC<ProjectsProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Projects</h1>
            <br />
            <p>
                Clicca qui sotto per scoprire il portfolio completo di STUDIO MISMO.
            </p>
            <br />
            <div style={styles.projectLinksContainer}>
                <ProjectBox
                    title="Portfolio MISMO"
                    subtitle="PROGETTI"
                    externalUrl="https://www.studiomismo.it/portfolio"
                />
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    projectLinksContainer: {
        flexDirection: 'column',
        width: '100%',
        display: 'flex',
        flex: 1,
    },
    projectLink: {
        marginBottom: 24,
        cursor: 'pointer',
        width: '100%',
        boxSizing: 'border-box',

        alignItems: 'center',
        justifyContent: 'space-between',
    },
    projectText: {
        justifyContent: 'center',
        flexDirection: 'column',
    },
    projectLinkLeft: {
        marginLeft: 16,
        alignItems: 'center',
    },
};

export default Projects;
